import { axiosInstance } from "./index";
import { ApiResponse } from "./types";

export const getContracts = async () => {
  const response = await axiosInstance.get<ApiResponse.GetContracts>(
    `/api/contracts`
  );
  return response;
};
